import { useQuery } from '@tanstack/react-query';
import {
  fetchInitialConfig,
  getOrganization,
  getSettings,
  getDateServiceConfig,
  type OrganizationConfig,
  type NormalizedSettings,
} from './initialApi';
import { keys } from '../../query/keyRegistry';
import { policies } from '../../query/policies';

export function useAppConfig() {
  const query = useQuery({
    queryKey: keys.app.config,
    queryFn: () => fetchInitialConfig(),
    staleTime: policies.config.staleTime,
    gcTime: policies.config.gcTime,
    refetchOnWindowFocus: false,
  });

  return {
    organization: getOrganization(),
    settings: getSettings(),
    dateService: getDateServiceConfig(),
    refreshConfig: () => query.refetch(),
    isLoading: query.isLoading,
    isFetching: query.isFetching,
  };
}

export function useOrganizationSettings(): {
  settings: NormalizedSettings & Record<string, unknown>;
} {
  const settings = {
    ...getDateServiceConfig(),
    ...getSettings(),
  };
  return { settings };
}

export function useApiConfig(): {
  organization: OrganizationConfig | null;
  refreshConfig: () => Promise<unknown>;
} {
  const { organization, refreshConfig } = useAppConfig();
  return { organization, refreshConfig };
}
